type ClarityFn = (...args: unknown[]) => void;
interface ClarityWindow extends Window {
	clarity?: ClarityFn & { q?: unknown[] };
}

/**
 * Load Microsoft Clarity if a project id is provided at build time via
 * `VITE_CLARITY_ID` (set as a CI secret). No-op otherwise, so local dev and
 * forks stay analytics-free.
 */
export function initAnalytics(): void {
	const id = import.meta.env.VITE_CLARITY_ID;
	if (!id) return;

	const w = window as ClarityWindow;
	w.clarity =
		w.clarity ??
		(((...args: unknown[]) => {
			(w.clarity!.q = w.clarity!.q ?? []).push(args);
		}) as ClarityWindow["clarity"]);

	const script = document.createElement("script");
	script.async = true;
	script.src = `https://www.clarity.ms/tag/${id}`;
	const first = document.getElementsByTagName("script")[0];
	first?.parentNode?.insertBefore(script, first);
}
